/* -------------------------------------------------------------------------- */
/* Page tabs                                                                  */
/* -------------------------------------------------------------------------- */
enum tab {
  MANAGE_NUMBERS = 'Manage Numbers',
  USAGE_SUMMARY = 'Usage Summary',
  REGULATORY_BUNDLE = 'Regulatory Bundle/Access',
  TOLL_FREE = 'Toll Free Number Registration',
  TRUST_CENTER = 'Trust Center',
  ADVANCE_SETTINGS = 'Advanced Settings',
  MESSAGING_STATS = 'Messaging Analytics',
  MESSAGING_SETTINGS = 'Messaging',
  VOICE_SETTINGS = 'Voice',
}

/* -------------------------------------------------------------------------- */
/* Modals Name                                                                */
/* -------------------------------------------------------------------------- */
enum modal {
  BUY_NUMBER = 'modal-buy-number',
  ADD_NUMBER_POOL = 'modal-add-number-pool',
  CONFIGURE_AND_REGISTER_NUMBERS = 'configure-and-register-numbers',
  DELETE_PHONE_NUMBER = 'modal-delete-phone-number',
  DELETE_NUMBER_POOL = 'modal-delete-number-pool',
  DELETE_VERIFIED_CALLER_ID = 'modal-delete-verified-caller-id',
  EDIT_PHONE_NUMBER = 'modal-edit-phone-number',
  EDIT_NUMBER_POOL = 'modal-edit-number-pool',
  EDIT_VERIFIED_CALLER_ID = 'modal-edit-verified-caller-id',
  PHONE_NUMBER_INFO = 'modal-phone-number-info',
  VERIFIED_CALLER_ID = 'modal-verified-caller-id',
  VERIFIED_CALLER_ID_FAILURE = 'modal-verified-caller-id-failure',
  VERIFIED_CALLER_ID_SUCCESS = 'modal-verified-caller-id-success',
  VERIFIED_CALLER_ID_VERIFICATION = 'modal-verified-caller-id-verification',
  VISITOR_SOURCE_TRACKING = 'modal-visitor-source-tracking',
  TRACKING_NUMBERS = 'modal-tracking-numbers',
  CONNECT_TELEPHONY = 'modal-connect-telephony',
  MESSAGING_TOLL_FREE = 'modal-messaging-toll-free',
}

/* -------------------------------------------------------------------------- */
/* Drawers Name                                                               */
/* -------------------------------------------------------------------------- */
enum drawer {
  NUMBER_POOL_INFO = 'number-pool-info',
  PHONE_NUMBER_INFO = 'phone-number-info',
}

/* -------------------------------------------------------------------------- */
/* Table Phone Numbers                                                        */
/* -------------------------------------------------------------------------- */
enum phoneNumberType {
  TOLL_FREE = 'Toll Free',
  MOBILE = 'mobile',
  LOCAL = 'Local',
  NATIONAL = 'National',
  HOSTED_NUMBER = 'Hosted Number',
  VERIFIED_CALLER_ID = 'Verified CallerID',
}

enum normalizedPhoneNumberType {
  TOLL_FREE = 'tollfree',
  MOBILE = 'mobile',
  LOCAL = 'local',
  NATIONAL = 'national',
  HOSTED_NUMBER = 'hostednumber',
  VERIFIED_CALLER_ID = 'verifiedcallerid',
}

/* -------------------------------------------------------------------------- */
/* Add Number Pool                                                            */
/* -------------------------------------------------------------------------- */
enum addNumberPoolSteps {
  WHAT_TRACKING = 'what-tracking',
  TRACKING_OPTIONS = 'tracking-options',
  NUMBER_POOL_CALL_FORWARDING = 'number-pool-call-forwarding',
  CHOOSE_NUMBERS = 'choose-numbers',
  NUMBER_FEATURES = 'number-features',
  SUCCESS = 'success',
}

enum addNumberPoolNextButton {
  'what-tracking' = 'Next: Tracking Options',
  'tracking-options' = 'Next: Create Pool',
  'number-pool-call-forwarding' = 'Next: Choose Numbers',
  'choose-numbers' = 'Next: Number Features',
  'number-features' = 'Activate Numbers',
  'success' = 'Done',
}

enum addNumberPoolModalDescription {
  'what-tracking' = 'What aspects of your website are you interested in monitoring?',
  'tracking-options' = 'Who would you like to monitor among your visitors? Select one option for now, but remember, you can always modify your choice later.',
  'number-pool-call-forwarding' = 'Direct incoming calls from your number pool seamlessly.',
  'choose-numbers' = 'Pick from a wide range of available numbers to best suit your business needs.',
  'number-features' = 'Explore various features and services your chosen number(s) can offer.',
  'success' = 'Your operation was successfully completed. Review the details here.',
}

enum trackingGoal {
  CAMPAIGN = 'campaign',
  VISITORS = 'visitors',
}

enum minPoolSize {
  CAMPAIGN = 1,
  VISITORS = 4,
}

/* -------------------------------------------------------------------------- */
/* Manage Numbers table tabs                                                  */
/* -------------------------------------------------------------------------- */
enum tableManageNumbersTab {
  PHONE_NUMBERS = 'Phone Numbers',
  NUMBER_POOLS = 'Number Pools',
  VERIFIED_CALLER_IDS = 'Verified Caller IDs',
}

enum tableManageNumbersTabsKey {
  PHONE_NUMBERS = 'phone-numbers',
  NUMBER_POOLS = 'number-pools',
  VERIFIED_CALLER_IDS = 'verified-caller-ids',
}

/**
 * Must map to keys of type "NumberPoolConfig" in location-numbers microapp: /src/types/LocationNumbers.ts
 */
enum numberPoolConfigKeys {
  ADDRESS_SID_REQUIRED = 'addressSIDRequired',
  ADDRESS_SID = 'addressSid',
  BUNDLE_SID = 'bundleSid',
  ALLOW_EXISTING_NUMBER = 'allowExistingNumber',
  CALL_RECORDING = 'callRecording',
  CALL_RECORDING_MESSAGE = 'callRecordingMessage',
  COUNTRY_CODE = 'countryCode',
  AREA_CODE = 'areaCode',
  FORWARDING_NUMBER = 'forwardingNumber',
  FRIENDLY_FORWARDING_NUMBER = 'friendlyForwardingNumber',
  NAME = 'name',
  NUMBER_TYPE = 'numberType',
  NUMBERS = 'numbers',
  PHONE_NUMBER_ACTION = 'phoneNumberAction',
  POOL_SIZE = 'poolSize',
  PURCHASE_CONFIRMATION = 'purchaseConfirmation',
  SWAPPING_CHECKBOX = 'swappingCheckbox',
  SWAPPING_NUMBER = 'swappingNumber',
  TRACKING_GOAL = 'trackingGoal',
  TRACKING_TYPE = 'trackingType',
  TRACKING_VALUE = 'trackingValue',
  WHISPER = 'whisper',
  WHISPER_MESSAGE = 'whisperMessage',
}

enum phoneNumberAction {
  LOCAL_NUMBERS = 'local',
  TOLL_FREE_NUMBERS = 'tollfree',
  DIFFERENT_AREA_CODE_NUMBERS = 'custom',
}

enum poolNumberType {
  TOLL_FREE = 'tollFree',
  MOBILE = 'mobile',
  LOCAL = 'local',
}

/* -------------------------------------------------------------------------- */
/* Messaging TollFree Verification                                            */
/* -------------------------------------------------------------------------- */

enum monthlyVolume {
  V10 = '10',
  V100 = '100',
  V1K = '1,000',
  V10K = '10,000',
  V100K = '100,000',
  V250K = '250,000',
  V500K = '500,000',
  V1M = '1,000,000',
  V5M = '5,000,000',
  V10M = '10,000,000+',
}

enum optInTypeValue {
  MOBILE_QR_CODE = 'MOBILE_QR_CODE',
  PAPER_FORM = 'PAPER_FORM',
  VERBAL = 'VERBAL',
  VIA_TEXT = 'VIA_TEXT',
  WEB_FORM = 'WEB_FORM',
}

enum optInTypeLabel {
  MOBILE_QR_CODE = 'Mobile / QR Code',
  PAPER_FORM = 'Paper Form',
  VERBAL = 'Verbal',
  VIA_TEXT = 'Via Text',
  WEB_FORM = 'Web Form',
}

enum useCaseCategoryValue {
  TWO_FACTOR_AUTHENTICATION = 'TWO_FACTOR_AUTHENTICATION',
  ACCOUNT_NOTIFICATIONS = 'ACCOUNT_NOTIFICATIONS',
  CUSTOMER_CARE = 'CUSTOMER_CARE',
  CHARITY_NONPROFIT = 'CHARITY_NONPROFIT',
  DELIVERY_NOTIFICATIONS = 'DELIVERY_NOTIFICATIONS',
  FRAUD_ALERT_MESSAGING = 'FRAUD_ALERT_MESSAGING',
  EVENTS = 'EVENTS',
  HIGHER_EDUCATION = 'HIGHER_EDUCATION',
  K12 = 'K12',
  MARKETING = 'MARKETING',
  POLLING_AND_VOTING_NON_POLITICAL = 'POLLING_AND_VOTING_NON_POLITICAL',
  POLITICAL_ELECTION_CAMPAIGNS = 'POLITICAL_ELECTION_CAMPAIGNS',
  PUBLIC_SERVICE_ANNOUNCEMENT = 'PUBLIC_SERVICE_ANNOUNCEMENT',
  SECURITY_ALERT = 'SECURITY_ALERT',
}

enum useCaseCategoryLabel {
  TWO_FACTOR_AUTHENTICATION = 'Two Factor Authentication',
  ACCOUNT_NOTIFICATIONS = 'Account Notifications',
  CUSTOMER_CARE = 'Customer Care',
  CHARITY_NONPROFIT = 'Charity Nonprofit',
  DELIVERY_NOTIFICATIONS = 'Delivery Notifications',
  FRAUD_ALERT_MESSAGING = 'Fraud Alert Messaging',
  EVENTS = 'Events',
  HIGHER_EDUCATION = 'Higher Education',
  K12 = 'K12',
  MARKETING = 'Marketing',
  POLLING_AND_VOTING_NON_POLITICAL = 'Polling And Voting Non-Political',
  POLITICAL_ELECTION_CAMPAIGNS = 'Political Election Campaigns',
  PUBLIC_SERVICE_ANNOUNCEMENT = 'Public Service Announcement',
  SECURITY_ALERT = 'Security Alert',
}

enum messagingTollFreeConfigKey {
  LEGAL_ENTITY_NAME = 'legalEntityName',
  WEBSITE_URL = 'websiteURL',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  EMAIL = 'email',
  COUNTRY_PHONE_CODE = 'countryPhoneCode',
  PHONE_NUMBER = 'phoneNumber',
  COUNTRY = 'country',
  ADDRESS = 'address',
  CITY = 'city',
  STATE = 'state',
  ZIP = 'zip',
  MONTHLY_VOLUME = 'monthlyVolume',
  OPT_IN_TYPE = 'optInType',
  USECASE_CATEGORIES = 'useCaseCategories',
  OPT_IN_IMAGE_URL = 'optInImageURL',
  USECASE_DESCRIPTION = 'useCaseDescription',
  MESSAGE_CONTENT = 'messageContent',
  TERMS_AND_CONDITIONS = 'termsAndConditions',
}

enum messagingTollFreeInputLabels {
  LEGAL_ENTITY_NAME = 'Legal Entity Name',
  WEBSITE_URL = 'Website URL',
  FIRST_NAME = 'First Name',
  LAST_NAME = 'Last Name',
  EMAIL = 'Email',
  PHONE_NUMBER = 'Phone Number',
  COUNTRY_PHONE_CODE = 'Country',
  ADDRESS = 'Address Line 1',
  CITY = 'City',
  STATE = 'State',
  ZIP = 'Postal/Zip Code',
  MONTHLY_VOLUME = 'Estimated Monthly Volume',
  OPT_IN_TYPE = 'Opt-In Type',
  USECASE_CATEGORIES = 'Use Case Categories',
  OPT_IN_IMAGE_URL = 'Opt-In Workflow Image URLs',
  USECASE_DESCRIPTION = 'Use Case Description',
  MESSAGE_CONTENT = 'Message Content',
  BUSINESS_REGISTRATION_TYPE = "Business Registration ID Type",
  BUSINESS_REGISTRATION_NUMBER = "Business Registration Number",
  BUSINESS_EMAIL = "Business Email",
  BUSINESS_TYPE = "Business Type",
  BUSINESS_INDUSTRY = "Business Industry",
  REGISTRATION_TYPE = "Name of the Registration Type",
  BUSINESS_REGIONS = "Business Regions",
  JOB_POSITION = "Job Position",
  BUSINESS_TITLE = "Business Title",
}

enum messagingTollFreeInputTooltip {
  LEGAL_ENTITY_NAME = "The legal business name is the one that appears on the government and legal forms.",
  FIRST_NAME = "Customer Point of Contact",
  OPT_IN_TYPE = "How will consumers be opting into SMS programs on this toll-free number?",
  OPT_IN_IMAGE_URL = "One or more URLs containing the screenshots or capture of the format or site where the customers input the information for opt-in. Please enter one URL per line.",
  BUSINESS_REGISTRATION_NUMBER = "The number that identifies the business in the country of registration.",
}

enum messagingTollFreeSteps {
  BUSINESS_AND_CONTACT = 'business-and-contact-information',
  BUSINESS_LOCATION = 'business-location',
  MESSAGING_USECASE = 'messaging-usecase',
}

enum messagingTollFreeNextButton {
  'business-and-contact-information' = 'Continue to Business location',
  'business-location' = 'Continue to Messaging use case',
  'messaging-usecase' = 'Send information for verification',
}

enum messagingTollFreeModalDescription {
  'business-and-contact-information' = 'To use this phone number for SMS/MMS, a verification process is required.',
  'business-location' = ''
}

/* -------------------------------------------------------------------------- */
/* Toll Free Verification                                                     */
/* -------------------------------------------------------------------------- */

enum tollFreeRequestStatus {
  PENDING_REVIEW = 'PENDING',
  IN_REVIEW = 'IN_REVIEW',
  TWILIO_APPROVED = 'APPROVED',
  TWILIO_REJECTED = 'REJECTED',
  REQUIRED = 'REQUIRED'
}

enum tollFreeRequestClientStatus {
  PENDING = 'PENDING',
  IN_REVIEW = 'IN_REVIEW',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  REQUIRED = 'REQUIRED'
}

/* -------------------------------------------------------------------------- */
/* Export Object                                                              */
/* -------------------------------------------------------------------------- */
const enums = {
  addNumberPoolModalDescription,
  addNumberPoolNextButton,
  addNumberPoolSteps,
  drawer,
  messagingTollFreeConfigKey,
  messagingTollFreeInputLabels,
  messagingTollFreeInputTooltip,
  messagingTollFreeModalDescription,
  messagingTollFreeNextButton,
  messagingTollFreeSteps,
  minPoolSize,
  modal,
  monthlyVolume,
  normalizedPhoneNumberType,
  numberPoolConfigKeys,
  optInTypeLabel,
  optInTypeValue,
  phoneNumberAction,
  phoneNumberType,
  poolNumberType,
  tab,
  tableManageNumbersTab,
  tableManageNumbersTabsKey,
  tollFreeRequestClientStatus,
  tollFreeRequestStatus,
  trackingGoal,
  useCaseCategoryLabel,
  useCaseCategoryValue,
}

export default enums
